import { Accordion, Button } from 'react-bootstrap'
import styled from 'styled-components'
import { isIframed } from '../../helpers/utils'

export const StyledAuthContainer = styled.div`
  position: absolute;
  top: 80px;
  right: ${({ right }) => right}px;
  max-width: 450px;
  width: 100%;
  min-height: 384px;
  background: var(--white);
  z-index: 99;
  border-top: 1px solid #d3d3d3;
  &:before,
  &:after {
    content: '';
    width: 0;
    height: 0;
    border-left: 14px solid transparent;
    border-right: 14px solid transparent;
    border-bottom: 14px solid #d3d3d3;
    position: absolute;
    top: -14px;
    left: 100px;
  }
  &:after {
    border-left: 13px solid transparent;
    border-right: 13px solid transparent;
    border-bottom: 13px solid var(--nav-gray);
    top: -13px;
    left: 101px;
  }
`

export const StyledAccordion = styled(Accordion)`
  .title-text {
    font-family: Open Sans;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 38px;
    letter-spacing: 0.15px;
    color: var(--black);
    z-index: 99;
  }
`

export const AccordionWrapper = styled.div`
  .nav-item {
    margin-left: 0px !important;
    margin-right: 0px !important;
    margin-top: auto;
    margin-bottom: auto;
  }

  .nav-tabs .nav-link.active {
    // box-shadow: 0px 5px 20px rgba(0, 0, 0, 20%);
    border-color: transparent;
  }

  .link-nav {
    margin-top: 15px;
    margin-left: 18px;
  }

  .first-tab-btn {
    height: 93px;
    width: 36%;
    border-bottom: ${({ navtabbtmfirst }) => navtabbtmfirst};
    z-index: 0;
    &::before {
      content: '';
      height: 93px;
      width: 53px;
      position: absolute;
      right: ${({ firstrightbefore }) => firstrightbefore};
      transform: skewX(25deg) !important;
      border-bottom: ${({ firsttabbtm }) => firsttabbtm};
      border-right: ${({ firsttabr }) => firsttabr};
    }
    &::after {
      content: '';
      height: 95px;
      width: 50px;
      top: 0;
      position: absolute;
      right: ${({ firstrightafter }) => firstrightafter};
      transform: skewX(25deg) !important;
      border-right: ${({ firsttabrafter }) => firsttabrafter};
      border-bottom: ${({ firsttabbtmafter }) => firsttabbtmafter};
    }
  }

  .first-tab-btn-mobile {
    height: 70px;
  }

  .md-mobile-width {
    width: 46%;
  }

  .second-tab-btn {
    height: 95px;
    // background: red;
    border-bottom: ${({ navtabbtmsec }) => navtabbtmsec};
    z-index: 0;
    &::before {
      content: '';
      height: ${({ secondh }) => secondh};
      width: 50px;
      position: absolute;
      right: ${({ secrightbefore }) => secrightbefore};
      transform: skewX(25deg) !important;
      border-bottom: ${({ secondtabbtm }) => secondtabbtm};
      border-right: ${({ secondtabright }) => secondtabright};
    }
    &::after {
      content: '';
      height: ${({ secondhafter }) => secondhafter};
      width: 50px;
      top: 0;
      position: absolute;
      right: ${({ secrightafter }) => secrightafter};
      transform: skewX(25deg) !important;
      border-right: ${({ secondtabrafterright }) => secondtabrafterright};
      border-bottom: ${({ secondtabrafterbtm }) => secondtabrafterbtm};
    }
  }

  .tab-btns {
    // background: red;
    z-index: 0;
    &::before {
      content: '';
      height: 94px;
      width: 50px;
      position: absolute;
      right: 362px;
      transform: skewX(25deg) !important;
      border-bottom: ${({ tabbtm }) => tabbtm};
      border-right: ${({ tabr }) => tabr};
    }
    &::after {
      content: '';
      height: 94px;
      width: 50px;
      position: absolute;
      right: 122px;
      transform: skewX(25deg) !important;
      border-right: ${({ tabrafter }) => tabrafter};
    }
  }

  .red {
    color: #eb5757 !important;
  }

  .purple {
    color: #9b51e0 !important;
  }

  .tracking-blue {
    color: #2f80ed;
  }

  .claims-green {
    color: #27ae60;
  }

  .supply-yellow {
    color: #f2c94c;
  }

  .ab-orange {
    color: #f2994a;
  }

  .group-blue {
    color: var(--primary);
  }
`

export const AccordionTabContainer = styled.div`
  .accordion-slant-before {
    position: relative;
    left: 77px;
    z-index: 3;
    height: 95px;
  }

  .card {
    border-radius: 0px;
    width: 100%;
    // border: 1px solid #e0e0e0;
    box-shadow: none;
  }

  @media (max-width: 1440px) {
    .card-deck .card {
      flex-basis: calc(25% - 27px);
    }
  }

  @media (min-width: 1440px) {
    .card-deck .card {
      flex-basis: calc(25% - 27px);
    }
  }

  .card-header {
    height: 95px;
    border: none;
    padding-right: 0px;
    padding-left: 0px;
    z-index: 99;
  }

  .card-header-desk {
    height: 95px;
    border: none;
    padding-right: 0px;
    padding-left: 0px;
    z-index: 99;
  }

  .card-header-mob {
    height: 150px;
    border: none;
    padding-right: 0px;
    padding-left: 0px;
    z-index: 99;
  }

  .header-border {
    border-top: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
  }

  .shadow {
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 20%);
  }

  .header-one {
    border-bottom: ${({ hbbtm }) => hbbtm};
    border-left: ${({ hbl }) => hbl};
    &::before {
      content: '';
      display: block;
      left: -23px;
      bottom: 1px;
      width: 50px;
      height: inherit;
      background: white;
      transform: skewX(25deg);
      position: relative;
    }
  }
`
export const UserMenuBackdrop = styled.div`
  background: #000000;
  opacity: 0.5;
  position: absolute;
  top: 60px;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 4;
  @media screen and (min-width: 992px) {
    top: 80px;
  }
`

export const ResultContainer = styled.div`
  @media print {
    @page {
      size: auto;
      width: 100vw;
    }
  }

  .badPackages {
    font-style: italic;
    text-transform: uppercase;
    font-weight: 700;
  }

  padding: 3rem;
  width: 100%;
  background-color: #333333;

  @media print {
    background-color: #ffffff;
  }

  .header {
    @media print {
      display: none;
    }
    span {
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 32px;
      letter-spacing: 0.15px;
      color: #ffffff;
    }

    p {
      margin-top: 0.668rem;
      background-color: transparent;
      font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 30px;
      color: #ffffff;
    }
  }

  hr {
    border-top: 1px solid white;

    @media print {
      border-top: 1px solid #333333;
    }
  }

  .information-header {
    span {
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 32px;
      letter-spacing: 0.15px;
      color: #ffffff;
      @media print {
        color: #333333;
      }
    }
  }

  .tracking-content {
    margin-top: 1.813rem;

    .label,
    .value {
      font-family: Open Sans;
      font-style: normal;
      font-size: 18px;
      line-height: 30px;
      color: #ffffff;
      @media print {
        color: #333333;
      }
    }

    .label {
      font-weight: 600;
    }

    .value {
      font-weight: normal;
    }
  }

  .click-details {
    margin-top: 1.25rem;
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 30px;
    color: #ffffff;
    cursor: pointer;

    :hover {
      text-decoration: underline;
    }

    @media print {
      display: none;
    }
  }

  .delivery-statuses-header,
  .delivery-statuses {
    font-family: Open Sans;
    font-style: normal;
    font-size: 18px;
    line-height: 30px;
    color: #ffffff;
  }

  .tracking-number {
    color: #ffffff;

    @media print {
      color: #333333;
    }
  }

  .delivery-statuses-header {
    margin-top: 1.813rem;
    font-weight: 600;
  }

  .delivery-statuses {
    font-weight: normal;
  }
  .footer-buttons {
    @media print {
      display: none;
    }
    margin-top: 3.313rem;

    .print-ready-container {
      display: flex;
      justify-content: flex-end;
    }
  }
  a.goBack {
    color: white;
    text-decoration: underline;

    @media print {
      color: #333333;
    }
  }

  hr {
    display: none;
  }

  @media screen and (max-width: ${isIframed ? '575' : '767'}px) {
    padding: 1rem;

    .delivery-statuses-header,
    .delivery-statuses {
      font-size: 15px;
      line-height: 20px;
    }
    .delivery-statuses {
      margin-bottom: 0.5rem;
    }

    .delivery-statuses-header {
      margin-top: 1rem;
      font-weight: 600;
    }

    hr {
      display: block;
    }

    .tracking-content {
      .label,
      .value {
        font-family: Open Sans;
        font-style: normal;
        font-size: 14px;
        line-height: 20px;
        color: #ffffff;
        @media print {
          color: #333333;
        }
      }

      .label {
        font-weight: 600;
      }

      .value {
        font-weight: normal;
      }
    }

    .print-ready-container {
      button {
        padding: 0;
        font-size: 15px;
      }
    }
  }
`

export const StyledButton = styled(Button)`
  @media screen and (max-width: 767px) {
    font-size: 14px;
    padding: 1rem;
  }
`
